import { customTv } from "#utils";

export const containerStyles = customTv({
  base: "flex items-center h-[1.25rem] w-[2.625rem] shrink-0 rounded-10 bg-clip-padding px-[3px] outline outline-1 transition duration-200 ease-in-out",
  variants: {
    isSelected: {
      false: "",
      true: "",
    },
    isHovered: {
      true: "",
    },
    isFocused: {
      true: "",
    },
    isDisabled: {
      true: "cursor-not-allowed",
    },
    uiVersion: {
      v1: "",
      v2: "",
    },
  },
  compoundVariants: [
    // V2 styling (existing behavior)
    {
      uiVersion: "v2",
      isSelected: false,
      class: "bg-background-primary outline-outline-input-enabled",
    },
    {
      uiVersion: "v2",
      isSelected: true,
      class: "bg-brand-primary outline-brand-primary",
    },
    {
      uiVersion: "v2",
      isFocused: true,
      class: "outline-2 outline-outline-brand",
    },
    // Unselected + Hovered
    {
      uiVersion: "v2",
      isSelected: false,
      isHovered: true,
      class: "outline-outline-input-hover",
    },
    // Unselected + Focused
    {
      uiVersion: "v2",
      isSelected: false,
      isFocused: true,
      class: "outline-outline-brand",
    },
    // Selected + Hovered
    {
      uiVersion: "v2",
      isSelected: true,
      isHovered: true,
      class:
        "bg-interactive-primary-button-hover-background outline-interactive-primary-button-hover-background",
    },
    // Selected + Focused
    {
      uiVersion: "v2",
      isSelected: true,
      isFocused: true,
      class:
        "bg-interactive-primary-button-focus-background outline-interactive-primary-button-focus-background",
    },
    // Disabled
    {
      uiVersion: "v2",
      isDisabled: true,
      isSelected: false,
      class: "bg-background-primary outline-interactive-disabled-outline",
    },
    {
      uiVersion: "v2",
      isDisabled: true,
      isSelected: true,
      class:
        "bg-interactive-secondary-button-focus-background outline-interactive-secondary-button-focus-background",
    },

    // V1 MUI-like styling
    {
      uiVersion: "v1",
      isSelected: false,
      class: "w-9 h-5 p-0 rounded-xl bg-[rgba(0,0,0,0.25)] outline-none",
    },
    {
      uiVersion: "v1",
      isSelected: true,
      class: "w-9 h-5 p-0 rounded-xl bg-legacy-orange-base outline-none opacity-100",
    },
    {
      uiVersion: "v1",
      isDisabled: true,
      class: "bg-gray-300 opacity-50 outline-none",
    },
  ],
});

export const circleStyles = customTv({
  base: "size-[.875rem] transform rounded-10 shadow-sm transition duration-200 ease-in-out",
  variants: {
    isSelected: {
      false: "",
      true: "",
    },
    isDisabled: {
      true: "",
    },
    uiVersion: {
      v1: "",
      v2: "",
    },
  },
  compoundVariants: [
    // V2 styling (existing behavior)
    {
      uiVersion: "v2",
      isSelected: false,
      class: "translate-x-0 bg-brand-primary",
    },
    {
      uiVersion: "v2",
      isSelected: true,
      class: "translate-x-[150%] bg-text-primary-inverse",
    },
    {
      uiVersion: "v2",
      isDisabled: true,
      isSelected: false,
      class: "bg-interactive-disabled-outline",
    },
    {
      uiVersion: "v2",
      isDisabled: true,
      isSelected: true,
      class: "bg-interactive-secondary-button-hover-background",
    },

    // V1 MUI-like styling
    {
      uiVersion: "v1",
      isSelected: false,
      class:
        "!w-[15px] !h-[15px] !rounded-[8px] !translate-x-[3px] !bg-neutral-white !shadow-[0_2px_4px_0_rgba(0,35,11,0.2)]",
    },
    {
      uiVersion: "v1",
      isSelected: true,
      class:
        "!w-[15px] !h-[15px] !rounded-[8px] !translate-x-[18px] !bg-neutral-white !shadow-[0_2px_4px_0_rgba(0,35,11,0.2)]",
    },
    {
      uiVersion: "v1",
      isDisabled: true,
      class: "!bg-neutral-white !opacity-50",
    },
  ],
});
